const getEnrollToken = async (param, http) => {
  // @ts-ignore
  const res = await http.get('/wemeet-tapi', '/enroll/v1/getEnrollToken', param);
  return res;
};
export default getEnrollToken;